export const DISPLAY_LANGUAGE_ALIASES = Object.freeze({
  en: 'en',
  eng: 'en',
  english: 'en',
  fr: 'fr',
  fre: 'fr',
  french: 'fr',
  francais: 'fr',
  es: 'es',
  spa: 'es',
  spanish: 'es',
});

export const DISPLAY_DB_LANGUAGE_BY_CODE = Object.freeze({
  en: 'English',
  fr: 'French',
  es: 'Spanish',
});

export function normalizeDisplayRouteLanguage(value) {
  if (!value) return null;
  const normalized = safeDecode(value).trim().toLowerCase();
  return DISPLAY_LANGUAGE_ALIASES[normalized] || null;
}

export function getDisplayLanguageLabel(languageCode) {
  return DISPLAY_DB_LANGUAGE_BY_CODE[languageCode] || 'English';
}

export function getDisplayRouteLanguageFromPathname(pathname) {
  if (!pathname) return null;

  const path = String(pathname).split('?')[0].split('#')[0].replace(/\/+$/g, '');
  const parts = path.split('/').filter(Boolean);

  if (parts.length !== 2 || parts[0] !== 'display') return null;
  return normalizeDisplayRouteLanguage(parts[1]);
}

function safeDecode(value) {
  try {
    return decodeURIComponent(String(value));
  } catch {
    return String(value);
  }
}